import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeaderLeft from "./HeaderLeft";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { SpinnerCircular } from "spinners-react";

function WelcomePersonalInfo() {
  let user = localStorage.getItem("user");
  user = JSON.parse(user);
  const token = GetStorage.get("xAuthToken");
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const [firstname, setFirstname] = useState(user.data.firstname);
  const [lastname, setLastname] = useState(user.data.lastname);
  const [mailing_address, setMailingAddress] = useState(user.data.mailing_address);
  const [street_name_1, setStreetName1] = useState(user.data.street_name_1);
  const [street_name_2, setStreetName2] = useState(user.data.street_name_2);
  const [state, setState] = useState(user.data.state);
  const [city, setCity] = useState(user.data.city);
  const [zipcode, setZipCode] = useState(user.data.zipcode);
  const [uploadSpin, setUploadSpin] = useState(false);

  useEffect(() => {}, []);
  const handleChangess = (event) => {
    setFirstname(event.target.value);
  };
  const handleChangesss = (event) => {
    setLastname(event.target.value);
  };
  const handleMailingAddress = (event) => {
    setMailingAddress(event.target.value);
  };
  
  const handleStreetName1 = (event) => {
    setStreetName1(event.target.value);
  };

  const handleStreetName2 = (event) => {
    setStreetName2(event.target.value);
  };

  const handleStateData = (event) => {
    setState(event.target.value);
  };

  const handleCityData = (event) => {
    setCity(event.target.value);
  };

  const handleZipCodeData = (event) => {
    setZipCode(event.target.value);
  };

  const onSubmits = async () => {
    setUploadSpin(true);
    http
      .put(`api/analyst/pinfo?token=${token}`, {
        firstname: firstname,
        lastname: lastname,
        // mailing_address: mailing_address,
        street_name_1: street_name_1,
        street_name_2: street_name_2,
        state: state,
        city: city,
        zipcode: zipcode,
      })
      .then((res) => {
        console.log("first name ------->>>>", res.data.message);
        setUploadSpin(false);

        navigate("/bankDetails");
      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          if (error.response.data.errors) {
            setError(error.response.data.errors)
            // for (let key in error.response.data.errors) {
            //   console.log("error.response.data.errors[key]",error.response.data.errors[key]);
            //   setError(error.response.data.errors[key]);
            // }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section class="otp_verification">
        <div class="login_inner custom_hight">
          <h1 class="mb_30 main_title ">Welcome {user.data.firstname}!</h1>
          <p class="mb_40 them_para text-center mx-auto text_limit">
            Set up your profile now... Enter your personal info.
          </p>
          <h6 class="sub_title mb_30">Personal Information</h6>
          <div class="container">
            <div class="row personal_info">
              <div class="col-lg-4 col-md-6 col-sm-6 mb-3">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    onChange={handleChangess}
                    value={firstname}
                  />{" "}
                </div>
              <h6 className="text-danger">{error && error.firstname}</h6>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-3">
                <div class="form-group">
                  <input
                    type="text"
                    id="message"
                    name="message"
                    onChange={handleChangesss}
                    value={lastname}
                    class="form-control"
                  />{" "}
                </div>
                <h6 className="text-danger">{error && error.lastname}</h6>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-3">
                <div class="form-group">
                  <input
                    disabled
                    type="email"
                    value={user.data.email}
                    class="form-control"
                  />{" "}
                </div>
                <h6 className="text-danger">{error && error.email}</h6>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-6 mb-3">
                <div class="form-group">
                  <input
                    disabled
                    type="text"
                    value={user.data.phone}
                    class="form-control"
                  />{" "}
                </div>
                <h6 className="text-danger">{error && error.phone}</h6>
              </div>
              {/* <div class="col-lg-4 col-md-6  mb-3">
                <div class="form-group">
                  <input
                    type="text"
                    id="message"
                    onChange={handleMailingAddress}
                    value={mailing_address}
                    class="form-control"
                    placeholder="Mailing Address"
                  />{" "}
                </div>
              </div> */}

              <div class="col-lg-4 col-md-6 col-sm-6 mb-3">
                <div class="form-group">
                  <input
                    type="text"
                    id="street_1"
                    onChange={handleStreetName1}
                    value={street_name_1}
                    class="form-control"
                    placeholder="Street Name 1"
                  />{" "}
                </div>
                <h6 className="text-danger">{error && error.street_name_1}</h6>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-6 mb-3">
                <div class="form-group">
                  <input
                    type="text"
                    id="street_2"
                    onChange={handleStreetName2}
                    value={street_name_2}
                    class="form-control"
                    placeholder="Street Name 2"
                  />{" "}
                </div>
                <h6 className="text-danger">{error && error.street_name_2}</h6>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-6 mb-3">
                <div class="form-group">
                  <input
                    type="text"
                    id="state"
                    onChange={handleStateData}
                    value={state}
                    class="form-control"
                    placeholder="State"
                  />{" "}
                </div>
                <h6 className="text-danger">{error && error.state}</h6>
              </div>
         
              <div class="col-lg-4 col-md-6 col-sm-6 mb-3">
                <div class="form-group">
                  <input
                    type="text"
                    id="city"
                    onChange={handleCityData}
                    value={city}
                    class="form-control"
                    placeholder="City"
                  />{" "}
                </div>
                <h6 className="text-danger">{error && error.city}</h6>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-6 mb-3">
                <div class="form-group">
                  <input
                    type="text"
                    id="zipcode"
                    onChange={handleZipCodeData}
                    value={zipcode}
                    class="form-control"
                    placeholder="Zipcode"
                  />{" "}
                </div>
                <h6 className="text-danger">{error && error.zipcode}</h6>
              </div>
            </div>
            <div class="btn_wraper">
              <button class="them_btn mt_40 mb_30" onClick={onSubmits}>
                {uploadSpin ? (
                  <SpinnerCircular className="button-spin" />
                ) : (
                  "  Continue"
                )}
              </button>
              {/* <button
                class="them_btn "
                onClick={() => navigate("/bankDetails")}
                style={{ marginLeft: 20 }}
              >
                Skip
              </button> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default WelcomePersonalInfo;
